<template>
  <q-list class="no-border">
    <q-item-label header class="q-pb-none">
      Citations
    </q-item-label>

    <q-item class="no-padding">
      <q-item-section class="q-pt-sm">
        <span class="__dimensions_badge_embed__" :data-doi="article.doi" data-legend="always"></span>
        <script src="https://badge.dimensions.ai/badge.js" type="application/javascript" defer charset="utf-8"></script>
      </q-item-section>
    </q-item>
  </q-list>
</template>

<script>
export default {
  props: {
    article: Object
  }
}
</script>
